import React, { useState, useEffect } from 'react';
import { Mail, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminSubscribers = () => {
  const { token } = useAuth();
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubscribers = async () => {
      try {
        const response = await axios.get(`${API}/admin/newsletter`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setSubscribers(response.data);
      } catch (error) {
        console.error('Error fetching subscribers:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchSubscribers();
  }, [token]);

  return (
    <div data-testid="admin-subscribers" className="p-6 lg:p-10">
      <div className="mb-10">
        <h1 className="text-3xl font-bold tracking-tight">
          Newsletter Subscribers
        </h1>
        <p className="mt-2 text-neutral-500">
          {subscribers.length} total subscriber{subscribers.length !== 1 ? 's' : ''}
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="spinner" />
        </div>
      ) : subscribers.length === 0 ? (
        <div className="text-center py-20">
          <Mail size={48} className="mx-auto text-neutral-300 mb-4" />
          <p className="text-neutral-500">No subscribers yet</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {subscribers.map((subscriber, index) => (
            <motion.div
              key={subscriber.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
              className="bg-white border border-neutral-200 p-6"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-neutral-100 flex items-center justify-center">
                  <Mail size={18} className="text-neutral-500" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium truncate">{subscriber.email}</p>
                  <div className="flex items-center gap-1 text-neutral-400 text-xs mt-1">
                    <Calendar size={12} />
                    <span>
                      {new Date(subscriber.subscribed_at).toLocaleDateString()}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminSubscribers;
